import React, { useContext } from "react";
import { Sparkles } from "lucide-react";

import { IntlContext } from "context";
import Seo from "components/Seo";
import { Badge } from "components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { ROUTES } from "routes";
import { ReactComponent as HeroTaglineUnderline } from "assets/images/hero-tagline-underline.svg";

import ContactForm from "./ContactForm";

const ContactPage: React.FC = () => {
    const intl = useContext(IntlContext);

    return (
        <>
            <Seo
                title={intl.formatMessage("contact.seo.title")}
                description={intl.formatMessage("contact.seo.description")}
                canonical={ROUTES.CONTACT}
                ogType="website"
            />
            <div className="bg-muted/30">
                <div className="mx-auto flex w-full max-w-2xl flex-col items-center gap-8 px-4 py-12 sm:px-6 lg:py-16">
                    <header className="flex flex-col items-center gap-4 text-center">
                        <Badge variant="featured">
                            <Sparkles aria-hidden />
                            {intl.formatMessage("contact.page.badge")}
                        </Badge>

                        <h1 className="text-4xl font-black tracking-tight text-foreground sm:text-5xl">
                            {intl.formatMessage("contact.page.title_prefix")}
                            <span className="relative inline-block text-primary">
                                {intl.formatMessage("contact.page.title_highlight")}
                                <HeroTaglineUnderline
                                    className="pointer-events-none absolute left-0 top-full h-auto w-full min-w-[8rem] max-w-none select-none"
                                    aria-hidden
                                />
                            </span>
                        </h1>

                        <p className="max-w-md text-sm text-muted-foreground sm:text-base">
                            {intl.formatMessage("contact.page.subtitle")}
                        </p>
                    </header>

                    <Card className="w-full rounded-3xl">
                        <CardHeader variant="centered">
                            <CardTitle className="text-xl font-bold sm:text-2xl">
                                {intl.formatMessage("contact.subtitle_1")}
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="mt-4 pb-8">
                            <ContactForm />
                        </CardContent>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default ContactPage;
